import { render, staticRenderFns } from "./payment3.vue?vue&type=template&id=b8e4f778&scoped=true&"
import script from "./payment3.vue?vue&type=script&lang=js&"
export * from "./payment3.vue?vue&type=script&lang=js&"
import style0 from "./payment3.vue?vue&type=style&index=0&id=b8e4f778&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e4f778",
  null
  
)

export default component.exports